function parseSuggestions(str: string): { recommended: boolean, new: boolean } {
    const result = { recommended: false, new: false };
    if (!str) return result;
    const recommendedMatch = str.match(/recommended=(true|false)/);
    const newMatch = str.match(/new=(true|false)/);
    if (recommendedMatch) result.recommended = recommendedMatch[1] === 'true';
    if (newMatch) result.new = newMatch[1] === 'true';
    return result;
}
import styles from "./SuggestionsFilter.module.css"
import CustomCheckbox from "@/components/UI/Buttons/Checkbox/CustomCheckbox";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { FilterState } from "../../page";

export default function SuggestionsFilter({ update, resetSignal, initialData }: {
    update: (name: string, value: string) => void,
    resetSignal: number,
    initialData: FilterState
}) {

    const [recommended, setRecommended] = useState(false)
    const [newGames, setNewGames] = useState(false)
    const t = useTranslations("Catalogue")
    useEffect(() => {
        if(!recommended) update('recommended', '')
        else update('recommended', 'recommended='+recommended)
    }, [recommended])

    useEffect(() => {
        if(!newGames) update('new', '')
        else update('new','new=' + newGames)
    }, [newGames])

    useEffect(() => {
        setRecommended(false)
        setNewGames(false)
    }, [resetSignal])

    useEffect(() => {
        const parsed = parseSuggestions(
            (initialData.recommended || '') + '&' + (initialData.new || '')
        );
        setRecommended(parsed.recommended);
        setNewGames(parsed.new);
    }, []);

    return (
        <div data-testid="SuggestionsFilter">
             <h4 className={`bodyTextMedium ${styles.title}`} data-testid="SuggestionsFilter_title">{t('suggestionsTitle')}</h4>
            <div className={styles.filters} data-testid="SuggestionsFilter_filters">
                <CustomCheckbox checked={recommended} onChange={() => setRecommended(prev => !prev)} id={'recommended'} label={t('recommendedLabel')}/>
                <CustomCheckbox checked={newGames} onChange={() => setNewGames(prev => !prev)} id={'new'} label={t('newLabel')}/>
            </div>
        </div>
    )
}